import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

const ENTITY_ID_KEY = 'xxx111otrckid';

export const getEntityId = () => {
  const entityId = Cookies.get(ENTITY_ID_KEY) || uuidv4();

  Cookies.set(ENTITY_ID_KEY, entityId);

  return entityId;
};
